import React from "react"

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui"

interface DialogModalProps {
  open: boolean
  onClose: () => void
  title: React.ReactNode
  children: React.ReactNode
}

export function DialogModal({ open, onClose, title, children }: DialogModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose} modal={true}>
      <DialogContent
        className="max-w-[90%] sm:max-w-md"
        showCloseButton={false}
        isDisabledPressBack={true}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="items-center text-center">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  )
}
